import { types, Instance } from 'mobx-state-tree';
const { model, string, identifierNumber, maybeNull, maybe, number } = types;

export const PaymentModel = model('PaymentModel', {
  id: identifierNumber,
  amount: string,
  currency: maybe(string),
  status: maybe(string),
  email: string,
  name: string,
  organizationName: maybeNull(string),
  subscriptionExpirationDate: maybeNull(string),
  subscriptionPaymentDate: string,
  noOfUsers: maybeNull(number),
});

export type IPaymentModel = Instance<typeof PaymentModel>;
